export class IdAndLabel {
  constructor(public id: any, public label: string) {}
}
